import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Premium / IA / nouveauté — étincelles duotone */
export const PremiumIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Étoile principale menthe */}
      <path d="M12 3l1.8 5.4 5.4 1.8-5.4 1.8L12 17.4l-1.8-5.4L4.8 10.2l5.4-1.8L12 3z" fill="var(--equiply-icon-bg)" />
      <path d="M12 3l1.8 5.4 5.4 1.8-5.4 1.8L12 17.4l-1.8-5.4L4.8 10.2l5.4-1.8L12 3z" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round" />
      {/* Petites étincelles bleues */}
      <path d="M19 16l.7 1.8L21.5 18.5l-1.8.7L19 21l-.7-1.8L16.5 18.5l1.8-.7L19 16z" fill="var(--equiply-icon-fg)" />
      <path d="M5 17l.5 1.3L7 18.7l-1.5.5L5 20.5l-.5-1.3L3 18.7l1.5-.5L5 17z" fill="var(--equiply-icon-fg)" />
    </svg>
  ),
);
PremiumIcon.displayName = "PremiumIcon";
